import { Bot, User, Headphones } from "lucide-react";
import { cn } from "@/lib/utils";
import AttachmentPreview from "./AttachmentPreview";

interface ChatMessageProps {
  role: "user" | "assistant" | "support";
  content: string;
  isSupport?: boolean;
  adminName?: string | null;
  adminEmail?: string | null;
  attachmentUrl?: string | null;
  attachmentType?: string | null;
  showAdminEmail?: boolean;
}

const ChatMessage = ({ 
  role, 
  content, 
  isSupport, 
  adminName, 
  adminEmail,
  attachmentUrl,
  attachmentType,
  showAdminEmail = false,
}: ChatMessageProps) => {
  const isSupportMessage = role === "support" || isSupport;
  const isUser = role === "user";
  
  return (
    <div className={cn("flex gap-2 items-end", isUser ? "flex-row-reverse" : "flex-row")}>
      <div
        className={cn(
          "w-8 h-8 rounded-full flex items-center justify-center shrink-0",
          isUser ? "bg-primary" : isSupportMessage ? "bg-primary" : "bg-crypto-gold"
        )}
      >
        {isUser ? (
          <User className="w-4 h-4 text-primary-foreground" />
        ) : isSupportMessage ? (
          <Headphones className="w-4 h-4 text-primary-foreground" />
        ) : (
          <Bot className="w-4 h-4 text-primary-foreground" />
        )}
      </div>
      <div
        className={cn(
          "max-w-[75%] px-4 py-2.5 rounded-2xl",
          isUser
            ? "bg-primary text-primary-foreground rounded-br-sm"
            : isSupportMessage
              ? "bg-primary/10 border border-primary/20 text-foreground rounded-bl-sm"
              : "bg-secondary text-foreground rounded-bl-sm"
        )}
      >
        {isSupportMessage && (
          <div className="mb-1">
            <p className="text-xs font-medium opacity-80">فريق الدعم</p>
            {showAdminEmail && adminEmail && (
              <p className="text-xs opacity-60">{adminEmail}</p>
            )}
          </div>
        )}
        <div className="text-sm leading-relaxed whitespace-pre-wrap">
          {content}
        </div>
        {attachmentUrl && attachmentType && (
          <AttachmentPreview url={attachmentUrl} type={attachmentType} />
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
